"use client";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import { useGetInfo } from "antopolis-react-utils/hooks";
import useAxiosPublicInstance from "@/hooks/useAxiosPublicInstance";

export default function Logo() {
  const axiosPublicInstance = useAxiosPublicInstance();

  const { info: data } = useGetInfo({
    axiosInstance: axiosPublicInstance,
    api: "websiteContents/websiteInfo",
  });

  return (
    <div className=" ">
      <div className="flex justify-center pt-2 items-center gap-1 ">
        {data?.websiteInfo?.image ? (
          <Link href="/">
            <div className="flex justify-center pt-2 items-center gap-1 ">
              <Image
                src={
                  process.env.NEXT_PUBLIC_SPACES_URL + data?.websiteInfo?.image
                }
                alt="logo"
                width={240}
                height={240}
                className="w-14"
              />
            </div>
          </Link>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
